import React from "react";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';
import { Link } from "react-router-dom/cjs/react-router-dom.min";


const Privacy = () => {
  return (
    <>
    <DynamicScrollToTop/>
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <Link to="/homepage"> 
                <p className="flex items-center text-font-gray opacity-50">
                  Beranda{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                </Link>
                <h1 className="text-font-gray">Kebijakan privasi</h1>
              </div>
              <div className="py-4 rounded bg-white">
                <div className="flex px-1  border-gray-300">
                  <div className="flex items-center p-4">
                    <h4 className="text-3xl font-semibold text-font-gray mb-2">
                      Perlindungan
                    </h4>
                  </div>
                </div>
                {/* Section Agreement */}
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      Mohon untuk membaca syarat dan ketentuan (“Syarat dan
                      Ketentuan”) yang tertulis di bawah ini secara seksama
                      sebelum memesan Barang atau menggunakan Layanan dari Situs
                      ini. Untuk menggunakan Layanan kami, Anda harus berumur 21
                      tahun atau lebih. Apabila Anda berumur di bawah 21 tahun,
                      maka anda membutuhkan izin dari orang tua atau wali anda.
                      Dengan tetap mengakses Situs ini dan memesan Barang atau
                      Layanan dari Situs ini melalui telepon atau aplikasi
                      telepon genggam kami, Anda setuju untuk terikat dengan
                      Syarat dan Ketentuan ini.
                    </p>
                  </div>
                </div>
                {/* End of section agreement */}
                <h3 className="ml-6 text-3xl font-semibold">1 . Pendahuluan</h3>
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      AGROTECH sebagai penyedia Platform mempunyai usaha di
                      bidang pengembangan, pengoperasian, pengaturan sebuah
                      online marketplace yang menyediakan daftar produk pada
                      agrotech.id sebuah domain internet yang didaftarkan atas
                      nama AGROTECH dan/atau Aplikasi iOS dan Android. OLEH
                      KARENA ITU PARA PIHAK SEPAKAT ATAS KETENTUAN DI BAWAH INI:
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Privacy;
